import { Box } from '@chakra-ui/react'

import AudioPlayerInline from 'src/components/widgets/AudioPlayerInline/AudioPlayerInline'
import { VoiceTipAnalyticsProps } from 'src/lib/hooks/analytics/useAnalytics'
import { BrandColor } from 'src/types'

export const VoiceTip: React.FC<{
  mediaUrl: string
  hasVoiceTip: boolean
  pictureUrl: string
  brandColor: BrandColor
  trackingData: VoiceTipAnalyticsProps
  title: string
}> = ({ mediaUrl, hasVoiceTip, pictureUrl, brandColor, trackingData, title }) =>
  hasVoiceTip ? (
    <Box
      mt={2}
      onClick={(ev) => {
        ev.preventDefault()
        ev.stopPropagation()
      }}
      position="relative"
      h="30px"
    >
      <Box position="absolute" zIndex="docked">
        <AudioPlayerInline
          mediaUrl={mediaUrl}
          title={title}
          pictureUrl={pictureUrl}
          brandColor={brandColor}
          trackingData={trackingData}
        />
      </Box>
    </Box>
  ) : null

export default VoiceTip
